import { QueryObject } from '../helpers/helpers';

/* eslint-disable func-names */
/* eslint-disable no-undef */
const accordion = () => {
  (function ($) {
    const $accordion = $('.js-accordion');
    const $accordionLocationPanel = $('.c-locations-accordion__panel');
    const accordionActive = 'o-accordion-header--active';
    const accordionIconOpen = 'o-accordion-icon--open';

    const queryObject = new QueryObject();

    $accordion.css('pointer-events', 'auto');

    $accordion.on('click', (e) => {
      e.preventDefault();
      const target = $(e.target).next();
      const isOpen = target[0].style.display === 'block';

      $accordion.removeClass(accordionActive);
      $accordion.children().removeClass(accordionIconOpen);
      $accordionLocationPanel.slideUp();

      if (isOpen) {
        target.slideUp();
        return;
      }

      $(e.target).toggleClass(accordionActive);
      $(e.target).children().toggleClass(accordionIconOpen);
      target.slideToggle();
    });

    // Automatically open the service accordion when there is a url parameter
    if (queryObject.params.service) {
      const $target = $(`[data-service-id=${queryObject.params.service}]`);
      $target.trigger('click');
      setTimeout(() => {
        console.log($target.offset(), $target[0].offsetTop);
        $('body,html').animate(
          { scrollTop: $target.offset().top - 100 }, 600,
        );
      }, 300);
    }
  }(jQuery));
};

export default accordion;
